module.exports = __webpack_public_path__ + "img/presention-chart.dea6f0c3.svg";